import { render, staticRenderFns } from "./chapter.vue?vue&type=template&id=1099c6fe&"
import script from "./chapter.vue?vue&type=script&lang=ts&"
export * from "./chapter.vue?vue&type=script&lang=ts&"
import style0 from "./chapter.vue?vue&type=style&index=0&id=1099c6fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports